import { render } from "./ProjectSelect.vue?vue&type=template&id=501c4864"
import script from "./ProjectSelect.vue?vue&type=script&lang=js"
export * from "./ProjectSelect.vue?vue&type=script&lang=js"
script.render = render

export default script